module.exports = __webpack_public_path__ + "img/file-earmark-easel.5d34e1ea.svg";